import React, {Component} from 'react';
import ProgressBar from 'react-bootstrap/ProgressBar'

//cal rebre a través de props: escrutat en format numeric

class BarraEscrutat extends Component {	
    render() {          
     return (
         <span className="barraEscrutat">
              {this.props.escrutat<50 && <ProgressBar striped variant="danger" now={this.props.escrutat} animated label={`${this.props.escrutat.toString().replace(/\./g, ',')}% escrutat`}/> }
              {this.props.escrutat>=50&&this.props.escrutat<85 && <ProgressBar striped variant="warning" now={this.props.escrutat} animated label={`${this.props.escrutat.toString().replace(/\./g, ',')}% escrutat`}/> }
              {this.props.escrutat>=85&&this.props.escrutat<99 && <ProgressBar striped variant="success" now={this.props.escrutat} animated label={`${this.props.escrutat.toString().replace(/\./g, ',')}% escrutat`}/> }
              {this.props.escrutat>=99 && <ProgressBar variant="success" now={this.props.escrutat} label={`${this.props.escrutat.toString().replace(/\./g, ',')}% escrutat`}/> }
        </span>
      );
    }
  }

  export default BarraEscrutat;